import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo

// opt-in Turbo, see: https://turbo.hotwired.dev/handbook/drive#disabling-turbo-drive-on-specific-links-or-forms
// TODO Remove this when the whole application is ready for Turbo.
Turbo.session.drive = false